import { createStore, combineReducers } from 'redux';

import AppReducer from './AppReducers';
import { USER_TOKEN, ENV } from '../constants/ConfigFileConstant';

const combineReducer = combineReducers({
  app: AppReducer,
});

const token = sessionStorage.getItem(USER_TOKEN);
const env = sessionStorage.getItem(ENV);
let tmp = null;


if (token != null) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  tmp = JSON.parse(window.atob(base64));
}

export const allReducer = createStore(
  combineReducer,
  {
    app: {
      token,
      id: tmp && tmp.id ? tmp.id : null,
      dns: 'https://api2mt.mytravo.net',
      version: 'v2',
      modal: false,
      register: false,
      login: false,
      reset: false,
      env,
    },
  },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);



// WEBPACK FOOTER //
// ./src/reducers/index.js